import publicReq from "./axiosConfig";

export const getAllAccessoriesService = () => publicReq.get("/accessory/all");
